import React from 'react';
import type { LucideProps } from 'lucide-react';

const SeasonIcon: React.FC<LucideProps> = ({ size = 24, className, color, style, 'aria-label': ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 118.34"
    aria-hidden={ariaLabel ? undefined : true}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : undefined}
    className={className}
    width={size}
    height={size}
    fill={color || 'currentColor'}
    style={{
      flexShrink: 0,
      ...style,
    }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.37 94.69c6.53 0 11.82 5.29 11.82 11.82 0 6.53-5.29 11.83-11.82 11.83s-11.82-5.29-11.82-11.83c-.01-6.53 5.28-11.82 11.82-11.82zm14.98-71.75c.09.04.17.09.24.15l6.41-13c5.99-9.89-3.32-12.41-5.78-7.99L68.1 18.87l8.25 4.07zm-29.82 0c-.09.04-.17.09-.24.15l-6.41-13C33.89.19 43.2-2.32 45.66 2.1l9.12 16.77-8.25 4.07zm29.49 62.12.15-.07 10.91-6.13c4.43 9.73 11.11 24.55 19.04 20.35 2.77-1.46 3.92-5.25 1.39-9.85-2.45-4.49-3.49-7.37 1.19-10.33 12.03-5.24 23.77 22.89 2.08 33.36-4.81 2.03-9.21 2.25-13.24.93-10.4-3.4-14.47-13.4-18.71-22.35l-2.81-5.91zm9.82-8.89L74.75 82.4 63.08 57.94l6.08-12.67 15.2 27.93c.45.81.94 1.82 1.48 2.97zM61.47 54.57l-.02-.04-1.63 3.43.01.03L48.13 82.4l-11.09-6.23c.54-1.14 1.03-2.15 1.48-2.97l28.16-51.75 8.36 4.13c.09.04.18.08.27.1L69 38.84l-.06-.1-1.56 3.28.05.09-5.96 12.46zm-7.55-15.82-2.7-5.66-3.65-7.41c.09-.02.18-.06.27-.1l8.36-4.13 3.57 6.56-5.85 10.74zm-7.06 46.31-.15-.07-10.91-6.13c-4.43 9.73-11.11 24.55-19.05 20.35-2.77-1.46-3.92-5.25-1.39-9.85 2.45-4.49 3.49-7.37-1.19-10.33-12.03-5.24-23.77 22.89-2.08 33.36 4.81 2.03 9.21 2.25 13.24.93 10.4-3.4 14.47-13.4 18.71-22.35l2.82-5.91zm14.51 13.45c4.42 0 8.01 3.59 8.01 8.01s-3.58 8.01-8.01 8.01-8.01-3.58-8.01-8.01 3.58-8.01 8.01-8.01z"
    />
  </svg>
);

export default SeasonIcon;
